import { connect } from 'react-redux';
import { parse } from 'query-string';
import { withRouter } from 'react-router';
import { branch, compose, lifecycle, renderComponent, withHandlers, withState } from 'recompose';
import { setRedirectionLink } from '../../../store/reducers/navigation';
import { Loader } from '../../../components/with-loader';

const mapStateToProps = ({ navigation }) => ({ redirectLink: navigation.redirectLink });

/**
 * This HOC is used to set redirect data `{redirectLink, redirectHistory}` after completing the account flow.
 * Used on first questions of sign up and sign in flows, as here we need to take the `rollbackLink` from the state.from.
 * `redirectHistory` is used to store the rollbackLink for the redirectLink.
 * This data is used in `getRedirectLinkAfterComplete` function in helpers/account/index.js
 * The redirectLink will be set unless user finishes the account registration flow (or only sign in).
 */
export const withRedirectAfterComplete = compose(
  connect(mapStateToProps, { setRedirectionLink }),
  withRouter,
  withState('processing', 'setProcessing', false),
  withHandlers({
    setRedirectLink:
      ({ redirectLink, setRedirectionLink, location: { search, state } }) =>
      () => {
        if (redirectLink) {
          return;
        }

        const redirectAfterComplete = parse(search).redirectAfterComplete;

        if (redirectAfterComplete) {
          const rollbackLink = state?.from;
          const redirectData = { link: redirectAfterComplete, rollbackLink };

          setRedirectionLink(redirectData);
        }
      }
  }),
  lifecycle({
    componentDidMount() {
      const { setRedirectLink, setProcessing } = this.props;

      setRedirectLink();
      setProcessing(true);
    }
  }),
  //this allows to first set redirectLink and then render the component
  branch(({ processing }) => !processing, renderComponent(Loader))
);
